import PropTypes from 'prop-types'

import { Icon } from '../display/icon'

const Headed2LogoChevronIcon = ({ label = 'Headed2LogoChevron', ...rest }) => {
  return (
    <Icon
      label={label}
      {...rest}
      dangerouslySetGlyph={`<svg data-name="Layer 1" viewBox="0 0 300 300"><path d="M121.9 150a31.7 31.7 0 1 1-31.6-31.7 31.6 31.6 0 0 1 31.6 31.7" style="fill:#b1ce5f"/><path d="M90.3 186.7a36.7 36.7 0 1 1 36.6-36.7 36.8 36.8 0 0 1-36.6 36.7zm0-63.4a26.7 26.7 0 1 0 26.6 26.7 26.8 26.8 0 0 0-26.6-26.7z" style="fill:#1d1d1b"/><path d="M130.6 273.2a26.1 26.1 0 0 1-19.6-43.1l69.9-80.1L111 69.9a26 26 0 0 1 39.2-34.2l84.8 97.2a26.1 26.1 0 0 1 0 34.2l-84.8 97.2a26.3 26.3 0 0 1-19.6 8.9" style="fill:#b1ce5f"/><path d="M130.6 278.2a31.3 31.3 0 0 1-20.4-7.7 31 31 0 0 1-10.5-21.2 30.4 30.4 0 0 1 7.6-22.5l67-76.8-67-76.8A31 31 0 1 1 154 32.5l84.8 97.1a31.3 31.3 0 0 1 0 40.8L154 267.5a30.9 30.9 0 0 1-23.4 10.7zm0-246.3a21.3 21.3 0 0 0-13.8 5.1 21 21 0 0 0-2 29.6l69.9 80.1a5.1 5.1 0 0 1 0 6.6l-69.9 80.1a20.6 20.6 0 0 0-5.1 15.2 20.9 20.9 0 0 0 36.7 12.4l84.8-97.2a21 21 0 0 0 0-27.6L146.4 39a20.8 20.8 0 0 0-15.8-7.1z" style="fill:#1d1d1b"/></svg>`}
    />
  )
}

Headed2LogoChevronIcon.propTypes = {
  onClick: PropTypes.func,
  label: PropTypes.string,
  color: PropTypes.string,
  size: PropTypes.oneOf(['tiny', 'small', 'medium', 'large'])
}

export { Headed2LogoChevronIcon }
